<div
  id="kiosk-scaler"
  class="relative overflow-hidden"
  [style.width.px]="TARGET_WIDTH * scale()"
  [style.height.px]="TARGET_HEIGHT * scale()">
  <div
    class="absolute top-0 left-0"
    [style.width.px]="TARGET_WIDTH"
    [style.height.px]="TARGET_HEIGHT"
    [style.transform]="'scale(' + scale() + ')'"
    style="transform-origin: top left">
    <router-outlet></router-outlet>
  </div>
</div>
